// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__3zaMb","error":"InputSecondary_error__1RPfx","disabled":"InputSecondary_disabled__108_-"};